import ApiClient from './apiClient'
import {
  ReportMember,
  MemberCondition,
  DailySearchCondition,
  MonthlySearchCondition,
  MemberReportCategoryWork,
  MemberReportApplicationProportion,
  ApplicationWorkTime,
  ApplicationTimeLine,
  MemberReportMixChart,
  MemberReportHeatMap,
  CustomSearchCondition,
} from '../types/member'

import {
  UserData,
  DataExists,
} from '../types/report'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportExists = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v2/renderer/member_report/daily/exists',
  (exists: DataExists) => exists,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportMember = async (params: MemberCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/member',
  (response: ReportMember) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUserData = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/daily/userdata',
  (response: UserData) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCategoryWork = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/daily/categorywork',
  (response: MemberReportCategoryWork) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApplicationProportion = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/daily/proportion',
  (response: MemberReportApplicationProportion) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getApplicationWorkTime = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/daily/applicationwork',
  (response: ApplicationWorkTime[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTimeLine = async (params: DailySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/daily/timeline',
  (response: ApplicationTimeLine[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyReportExists = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v2/renderer/member_report/monthly/exists',
  (exists: DataExists) => exists,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyUserData = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/monthly/userdata',
  (response: UserData) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyCategoryWork = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/monthly/categorywork',
  (response: MemberReportCategoryWork) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyApplicationProportion = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/monthly/proportion',
  (response: MemberReportApplicationProportion) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyApplicationWorkTime = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/monthly/applicationwork',
  (response: ApplicationWorkTime[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyTimeLine = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/monthly/timeline',
  (response: ApplicationTimeLine[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyMixChart = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/monthly/mixchart',
  (response: MemberReportMixChart) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getMonthlyHeatMap = async (params: MonthlySearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/monthly/heatmap',
  (response: MemberReportHeatMap) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomReportExists = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/exists',
  (exists: DataExists) => exists,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomUserData = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/userdata',
  (response: UserData) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomCategoryWork = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/categorywork',
  (response: MemberReportCategoryWork) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomApplicationProportion = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/proportion',
  (response: MemberReportApplicationProportion) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomApplicationWorkTime = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/applicationwork',
  (response: ApplicationWorkTime[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomTimeLine = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/timeline',
  (response: ApplicationTimeLine[]) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomMixChart = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/mixchart',
  (response: MemberReportMixChart) => response,
  params,
)

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCustomHeatMap = async (params: CustomSearchCondition): Promise<any> => ApiClient.get(
  '/api/v1/renderer/member_report/range/heatmap',
  (response: MemberReportHeatMap) => response,
  params,
)
